<template>
  <lazy-component>
    <div class="tweet-wrapper"><tweet :id="id" :options="options" /></div>
  </lazy-component>
</template>

<script>
import { Tweet } from "vue-tweet-embed";

export default {
  name: "app-youtube",
  components: { Tweet },
  props: {
    id: {
      type: String,
      required: true
    },
    darktheme: {
      type: String,
      default: false
    },
    showcard: {
      type: String,
      default: true
    }
  },
  computed: {
    options() {
      return {
        theme: this.darktheme == "true" ? "dark" : "light",
        cards: this.showcard == "true" ? "true" : "hidden"
      };
    }
  }
};
</script>

<style scoped lang="scss">
.tweet-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
